import styled from "styled-components"
import { colors } from "../../Utils/color"

const PaginationDiv = styled.div`
    display: flex;
    justify-content: center;
    gap: 5px;
    margin-bottom: 60px;

    > button {
        font-size: 0.92em;
        font-weight: 600;
        color: ${colors.textColor};
        background-color: rgba(190, 190, 190, 0.2);
        border: none;
        border-radius: 8px;
        padding: 10px 15px;
        cursor: pointer;

        &:hover {
            background-color: rgba(190, 190, 190, 0.05);
        }

        > .fa-solid {
            font-size: 0.85em;
        }
    }

    > .active {
        background-color: ${colors.primary};
    }
    > .desabled {
        background-color: rgba(190, 190, 190, 0.05);
        color: rgba(250, 250, 250, 0.4);
        cursor: not-allowed;
    }
`

function PaginationMovies({ currentPage, totalPages, onPageChange }) {
    //const pages = Array.from({ length: totalPages }, (_, i) => i + 1)

    const getPages = () => {
        const pages = []
        const delta = 2 // nombre de pages visibles autour de la page active

        // Plage de pages autour de la page active
        const range = [
            Math.max(2, currentPage - delta),
            Math.min(totalPages - 1, currentPage + delta),
        ]

        // Ajoute la première page
        pages.push(1)

        // Ajoute "..." si nécessaire
        if (range[0] > 2) {
            pages.push("...")
        }

        // Ajoute les pages intermédiaires
        for (let i = range[0]; i <= range[1]; i++) {
            pages.push(i)
        }

        // Ajoute "..." si nécessaire
        if (range[1] < totalPages - 1) {
            pages.push("...")
        }

        // Ajoute la dernière page
        if (totalPages > 1) {
            pages.push(totalPages)
        }

        return pages
    }

    return (
        <PaginationDiv>
            <button
                id="prevPage"
                className={currentPage === 1 ? "desabled" : ""}
                onClick={() => onPageChange(currentPage - 1)}
            >
                <i className="fa-solid fa-chevron-left"></i>
            </button>

            {getPages().map((page, idx) =>
                page === "..." ? (
                    <button
                        key={idx}
                        className="px-3 py-1"
                        style={{ cursor: "default" }}
                    >
                        ...
                    </button>
                ) : (
                    <button
                        key={idx}
                        className={currentPage === page ? "active" : ""}
                        onClick={() => onPageChange(page)}
                    >
                        {page}
                    </button>
                )
            )}

            <button
                id="nextPage"
                className={currentPage === totalPages ? "desabled" : ""}
                onClick={() => onPageChange(currentPage + 1)}
            >
                <i className="fa-solid fa-chevron-right"></i>
            </button>
        </PaginationDiv>
    )
}

export default PaginationMovies
